module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Coffee1-fd1073368f44799f7e1c4c253ade4b0c.svg";